// extracted by mini-css-extract-plugin
export var columnList = "_ak-0";